<template>
  <div class="dashboard">
    <div class="message">
      <DashboardMessage />
    </div>
    <h3 class="dashboard-title">Current Status</h3>
    <DashboardShow3 />
    <h3 class="dashboard-title">Lastest Update</h3>
    <DashboardTable />
  </div>
</template>
<script>
import DashboardMessage from "../components/DashboardMessage.vue";
import DashboardShow3 from "./DashboardShow3";
import DashboardTable from "./DashboardTable";

export default {
  name: "DashboardHome",
  components: {
    DashboardShow3,
    DashboardTable,
    DashboardMessage,
  },
  data() {
    return {
      fields: [
        { key: "status", label: "status" },
        { key: "date", label: "Submitted Date" },
        { key: "name", label: "Candidate Name" },
        { key: "job", label: "Job" },
        // { key: "nameage", label: "First name and age" },
      ],
      items: [
        {
          status: "employed",
          name: { first: "John", last: "Doe" },
          date: "04/02/2021",
          job: "Job ID:123456",
        },
      ],
    };
  },
};
</script>
<style lang="scss">
@import "~@/assets/stylesheets/application";
.message {
  margin-bottom: 1.5rem;
}
</style>
